<template>
  <div
  class="chatter-icon-com"
  :class="{
    'is-white': is_white,
    'chatterIcon-zero': unread === 0,
    'chatterIcon-unread': unread > 0
  }"
  @click="onClick"
  >
    <div v-if="unread === 0">
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.00009 5H15.0001M5.00009 8.5H15.0001M5.00009 12H15.0001M5.00009 16V18.3355C5.00009 18.8684 5.00009 19.1348 5.10932 19.2716C5.20431 19.3906 5.34836 19.4599 5.50063 19.4597C5.67572 19.4595 5.88376 19.2931 6.29985 18.9602L8.6853 17.0518C9.17261 16.662 9.41626 16.4671 9.68758 16.3285C9.92829 16.2055 10.1845 16.1156 10.4493 16.0613C10.7478 16 11.0598 16 11.6838 16H14.2001C15.8802 16 16.7203 16 17.3621 15.673C17.9265 15.3854 18.3855 14.9265 18.6731 14.362C19.0001 13.7202 19.0001 12.8802 19.0001 11.2V5.8C19.0001 4.11984 19.0001 3.27976 18.6731 2.63803C18.3855 2.07354 17.9265 1.6146 17.3621 1.32698C16.7203 1 15.8802 1 14.2001 1H5.80009C4.11993 1 3.27986 1 2.63812 1.32698C2.07363 1.6146 1.61469 2.07354 1.32707 2.63803C1.00009 3.27976 1.00009 4.11984 1.00009 5.8V12C1.00009 12.93 1.00009 13.395 1.10231 13.7765C1.37972 14.8117 2.18836 15.6204 3.22363 15.8978C3.60513 16 4.07012 16 5.00009 16Z" :stroke="is_white ? '#FFFFFF' : '#666666'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div v-else>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0001 8.5V5M10.0001 12H10.0101M5.00009 16V18.3355C5.00009 18.8684 5.00009 19.1348 5.10932 19.2716C5.20431 19.3906 5.34836 19.4599 5.50063 19.4597C5.67572 19.4595 5.88376 19.2931 6.29985 18.9602L8.6853 17.0518C9.17261 16.662 9.41626 16.4671 9.68758 16.3285C9.92829 16.2055 10.1845 16.1156 10.4493 16.0613C10.7478 16 11.0598 16 11.6838 16H14.2001C15.8802 16 16.7203 16 17.3621 15.673C17.9265 15.3854 18.3855 14.9265 18.6731 14.362C19.0001 13.7202 19.0001 12.8802 19.0001 11.2V5.8C19.0001 4.11984 19.0001 3.27976 18.6731 2.63803C18.3855 2.07354 17.9265 1.6146 17.3621 1.32698C16.7203 1 15.8802 1 14.2001 1H5.80009C4.11993 1 3.27986 1 2.63812 1.32698C2.07363 1.6146 1.61469 2.07354 1.32707 2.63803C1.00009 3.27976 1.00009 4.11984 1.00009 5.8V12C1.00009 12.93 1.00009 13.395 1.10231 13.7765C1.37972 14.8117 2.18836 15.6204 3.22363 15.8978C3.60513 16 4.07012 16 5.00009 16Z" :stroke="is_white ? '#FFFFFF' : '#7F56D9'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span
        v-if="unread > 0"
        class="unread-badge"
        :class="{
          'unread-badge-9plus': unread > 9
        }"
      >
        {{ unread > 9 ? '9+' : unread }}
      </span>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  unread: {
    type: Number,
    default: 0,
  },
  is_white: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(['click']);

const onClick = () => {
  emit('onClick');
};
</script>
<style>
.chatter-icon-com.chatterIcon-zero {
  position: relative;
  display: inline-block;
  cursor: url("../assets/cursorArrow.svg"), auto;
  text-align: center;
  width: 25px;
  height: 25px;
}
.chatter-icon-com.chatterIcon-unread {
  position: relative;
  display: inline-block;
  cursor: url("../assets/cursorArrow.svg"), auto;
  text-align: center;
  width: 26px;
  height: 26px;
}
.chatter-icon-com.is-white.chatterIcon-unread {
  position: relative;
  display: inline-block;
  cursor: url("../assets/cursorArrow.svg"), auto;
  text-align: center;
  width: fit-content;
  padding: 3px 3px 0px 3px;
}
.chatter-icon-com.is-white.chatterIcon-unread div {
  position: relative;
  bottom: -2px;
}
.chatter-icon-com.chatterIcon-zero:hover {
  background-color: #344054;
  text-align: center;
  box-shadow: 0px 4px 4px 0px #0000000f;
  border-radius: 4px; 
}
.chatter-icon-com.chatterIcon-zero:hover svg path {
  stroke: #FCFCFE !important;
}
.chatter-icon-com.chatterIcon-zero svg path {
  stroke: #666666;
}
.chatter-icon-com.is-white.chatterIcon-zero svg path {
  stroke: #FFFFFF; /* White stroke for zero unread when is_white is true */
}
.chatter-icon-com.chatterIcon-unread .unread-badge {
  position: absolute;
  top: -3px;
  right: -1px;
  background-color: #7F56D9;
  color: #FFFFFF;
  border-radius: 10px;
  padding: 0 4px;
  font-size: 6px;
  text-align: center;
  transform: translate(-15%, 40%);
  font-weight: bold;
}
.chatter-icon-com.is-white.chatterIcon-zero div {
  margin: 0px auto;
  width: 26px;
  height: 26px;
}
.chatter-icon-com.is-white.chatterIcon-zero div:hover {
  background-color: #FFFFFF;
  text-align: center;
  box-shadow: 0px 4px 4px 0px #0000000f;
  border-radius: 4px; 
}
.chatter-icon-com.is-white.chatterIcon-zero:hover svg path {
  stroke: #666666 !important;
}
.chatter-icon-com.chatterIcon-unread .unread-badge-9plus {
  padding: 0 2px;
}
.chatter-icon-com.is-white {
  background: #666666;
  border-radius: 4px;
}
.chatter-icon-com.is-white.chatterIcon-zero {
  position: relative;
  top: 2px;
  width: 26px;
  height: 26px;
}
.chatter-icon-com.is-white.chatterIcon-unread {
  position: relative;
  top: 3px;
}
.chatter-icon-com.is-white.chatterIcon-unread .unread-badge {
  position: absolute;
  top: 0px;
  right: 0;
  background-color: #E6DDF9 !important;
  color: #344054 !important;
  border-radius: 10px;
  padding: 0 4px;
  font-size: 6px;
  text-align: center;
  transform: translate(25%, -40%);
  font-weight: bold;
}
.chatter-icon-com.is-white.chatterIcon-unread svg path {
  stroke: #E6DDF9;
}
.chatter-icon-com.is-white.chatterIcon-unread .unread-badge-9plus {
  padding: 0 2px !important;
  height: 8px;
}
.chatter-icon-com.chatterIcon-zero div > svg {
  position: relative !important;
  top: 2.5px !important;
}
.chatter-icon-com.chatterIcon-unread:hover {
  background-color: #344054;
  text-align: center;
  box-shadow: 0px 4px 4px 0px #0000000f;
  border-radius: 4px; 
}
.chatter-icon-com.chatterIcon-unread:hover svg path {
  stroke: #FCFCFE !important;
}
.chatter-icon-com.chatterIcon-unread svg {
  position: relative;
  top: 3px;
}
.chatter-icon-com.is-white.chatterIcon-unread:hover {
  background-color: #FFFFFF;
  text-align: center;
  box-shadow: 0px 4px 4px 0px #0000000f;
  border-radius: 4px; 
}
.chatter-icon-com.is-white.chatterIcon-unread:hover svg path {
  stroke: rgb(102, 102, 102) !important
}
.chatter-icon-com.is-white.chatterIcon-unread svg {
  top: -2px;
}
</style>
